import { Button } from 'components'
import ModalWindow from 'hooks/ModalWindow/ModalWindow'
import PinCode from 'hooks/PinCode/PinCode'
import { useTranslation } from 'react-i18next'

import styles from './ProfilePinModals.module.scss'

const ProfilePinModals = ({
  openModalPassword,
  setOpenModalPassword,
  openModal,
  setOpenModal,
  modalText,
  verifyPin,
  setPinCode,
  onPasswordValidate,
  onPinValidate,
  onCreateUserPin,
}) => {
  const { t } = useTranslation('common')
  return (
    <>
      <ModalWindow
        openModal={openModalPassword}
        setOpenModal={setOpenModalPassword}
        modalText={t('profile.pin.enter_pin_label')}
        width={'unset'}
      >
        <PinCode setPinCode={setPinCode} passwordVisible={false} />
        <Button
          onClick={() => setOpenModalPassword(false)}
          className={styles.btn_pin_close}
        >
          {t('common.close')}
        </Button>
        <Button onClick={onPasswordValidate} className={styles.btn_pin}>
          {t('common.confirm')}
        </Button>
      </ModalWindow>

      <ModalWindow
        openModal={openModal}
        setOpenModal={setOpenModal}
        modalText={modalText}
      >
        {verifyPin === false ? (
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {t('common.close')}
            </Button>
            <Button onClick={onPinValidate} className={styles.btn_pin}>
              {t('common.confirm')}
            </Button>
          </>
        ) : (
          <>
            <PinCode setPinCode={setPinCode} passwordVisible={false} />
            <Button
              onClick={() => setOpenModal(false)}
              className={styles.btn_pin_close}
            >
              {t('common.close')}
            </Button>
            <Button onClick={onCreateUserPin} className={styles.btn_pin}>
              {t('profile.change')}
            </Button>
          </>
        )}
      </ModalWindow>
    </>
  )
}

export default ProfilePinModals
